var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_40_23",
    "data-name": "Component 40 \\u2013 23",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_4",
    "data-name": "Repeat Grid 4",
    transform: "translate(13 13)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 -15)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_681",
    "data-name": "Ellipse 681",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(11 15)",
    fill: "rgba(48,110,243,0.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682",
    "data-name": "Ellipse 682",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(19 15)",
    fill: "rgba(48,110,243,0.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_683",
    "data-name": "Ellipse 683",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(27 15)",
    fill: "rgba(48,110,243,0.8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_681-2",
    "data-name": "Ellipse 681",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(11 15)",
    fill: "rgba(48,110,243,0.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682-2",
    "data-name": "Ellipse 682",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(19 15)",
    fill: "rgba(48,110,243,0.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_683-2",
    "data-name": "Ellipse 683",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(27 15)",
    fill: "rgba(48,110,243,0.8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_681-3",
    "data-name": "Ellipse 681",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(11 15)",
    fill: "rgba(48,110,243,0.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682-3",
    "data-name": "Ellipse 682",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(19 15)",
    fill: "rgba(48,110,243,0.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_683-3",
    "data-name": "Ellipse 683",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(27 15)",
    fill: "rgba(48,110,243,0.8)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarNav);
export default __webpack_public_path__ + "static/media/navbar-nav.7617cd0acadf2e86f1a5f4a8b8f4852c.svg";
export { ForwardRef as ReactComponent };